import { configuredSiteOrigin } from './seo-generator';

const SENSITIVE_QUERY_KEYS = new Set([
  'token',
  'accesstoken',
  'publictoken',
  'ticketaccesstoken',
  'sessiontoken',
  'recoverytoken',
  'authorization',
  'password',
]);

export function isSensitiveRedirectKey(key: string): boolean {
  return SENSITIVE_QUERY_KEYS.has(key.toLowerCase().replace(/[^a-z0-9]/g, ''));
}

function publicQuery(query: string): string {
  return query
    .split('&')
    .filter((part) => {
      try {
        return !isSensitiveRedirectKey(
          decodeURIComponent(part.split('=')[0].replace(/\+/g, ' '))
        );
      } catch {
        return false;
      }
    })
    .join('&');
}

// Narrow public GET/HEAD normalization only. Never apply to auth, signed links,
// callbacks or transaction URLs. The deployment origin is the sole redirect host.
export function publicUrlRedirect(
  originalUrl: string,
  siteBaseUrl: string
): { status: 301; location: string } | { status: 400 } | null {
  const queryAt = originalUrl.indexOf('?');
  const path = queryAt < 0 ? originalUrl : originalUrl.slice(0, queryAt);
  const query = queryAt < 0 ? '' : originalUrl.slice(queryAt + 1);
  const alias = /^\/(?:e|event)\/([^/]+)\/?$/.exec(path);
  let target: string | undefined;
  if (alias) {
    let slug: string;
    try {
      slug = decodeURIComponent(alias[1]);
    } catch {
      return { status: 400 };
    }
    if (
      !slug ||
      slug.length > 255 ||
      /[/\\\s?#]/.test(slug) ||
      Array.from(slug).some(
        (character) =>
          character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127
      ) ||
      ['.', '..'].includes(slug)
    ) {
      return { status: 400 };
    }
    target = `/evento/${encodeURIComponent(slug)}`;
  } else if (
    /^\/(?:sobre|ajuda|contato|organizadores|perguntas-frequentes|politica-de-privacidade|termos-de-uso|preferencias-de-cookies|eventos(?:\/[^/]+){0,2}|evento\/[^/]+)\/$/.test(
      path
    )
  ) {
    target = path.slice(0, -1);
  }
  if (!target) return null;
  const safeQuery = publicQuery(query);
  return {
    status: 301,
    location: `${configuredSiteOrigin(siteBaseUrl)}${target}${
      safeQuery ? `?${safeQuery}` : ''
    }`,
  };
}
